export const COUNT_UP_DURATION_MS = 500
export const COUNT_UP_EASING = [0.950, 0.050, 0.795, 0.035] as const
export const SUMMARY_REVALIDATE_DELAY_MS = COUNT_UP_DURATION_MS + 400
